import React from 'react';
import { Grid } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/AttributionManager/messages';
import EmptyInboxesImage from 'images/inboxes-empty-icon.svg';
import {
  StyledTitleSubIcon,
  StyledSpacingTop,
} from 'containers/AttributionManager/styles';

export interface EmptySelectedInboxesProps {
  intl: IntlShape;
}

export const EmptySelectedInboxes: React.FC<EmptySelectedInboxesProps> = (
  props,
): JSX.Element => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      style={StyledSpacingTop}
    >
      <Grid item>
        <img src={EmptyInboxesImage} alt="empty inboxe" />
      </Grid>
      <Grid item>
        <span style={StyledTitleSubIcon}>
          {translate(messages.managerInboxesEmptyStateTitle, props)}
        </span>
      </Grid>
      <Grid item></Grid>
    </Grid>
  );
};

export default injectIntl(EmptySelectedInboxes);
